import * as React from "react";
import { Box, Typography } from "@mui/material";
import RecentActivityPanel from "../../../components/recentActivity/RecentActivityPanel";

const HomeRecentActivity: React.FC = () => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                width: 1,
                border: "1px solid #E0E0E0",
                borderRadius: "4px",
                padding: 2,
            }}
        >
            <Typography variant="h6" fontWeight="bold" sx={{ marginBottom: 1 }}>
                Recent Activity
            </Typography>
            <RecentActivityPanel maxHeight={350} />
        </Box>
    );
};

export default HomeRecentActivity;
